var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { uploadImage } from "@/06-shared/api";
import { createImageMarkdown, createUploadErrorMarkdown } from "./imageMarkdown";
import { replaceUploadPlaceholder } from "./replaceUploadPlaceholder";
export const uploadClipboardImage = (view, file, placeholder) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const { url } = yield uploadImage(file);
        replaceUploadPlaceholder(view, placeholder, createImageMarkdown(file, url));
    }
    catch (error) {
        replaceUploadPlaceholder(view, placeholder, createUploadErrorMarkdown(file));
        console.error("Failed to upload pasted image", error);
    }
});
